import { KnowledgebaseQuestion } from './KnowledgebaseQuestion';
import { useSelector } from 'react-redux';
import { RootState } from '@/types/graph';

type KnowledgebaseQuestionAndInfoQuestionProps = {
  infoQuestionId: string;
  normalQuestionId: string;
  showErrors: boolean;
  invalidQuestions: string[];
  resetErrors: () => void;
  setHasFreshSelection: (hasFreshSelection: boolean) => void;
  setIsQuestionExiting: (exiting: boolean) => void;
};

export const KnowledgebaseQuestionAndInfoQuestion = ({
  infoQuestionId,
  normalQuestionId,
  showErrors,
  invalidQuestions,
  resetErrors,
  setHasFreshSelection,
}: KnowledgebaseQuestionAndInfoQuestionProps) => {
  const currentPage = useSelector(
    (state: RootState) => state.graph.currentPage,
  );

  return (
    <>
      <KnowledgebaseQuestion
        key={infoQuestionId}
        extId={infoQuestionId}
        currentPage={currentPage}
        error={showErrors && invalidQuestions.includes(infoQuestionId)}
        resetErrors={resetErrors}
        onFreshSelection={() => setHasFreshSelection(true)}
        style={{ animationDelay: `${50}ms` }}
      />
      <KnowledgebaseQuestion
        key={normalQuestionId}
        extId={normalQuestionId}
        currentPage={currentPage}
        error={showErrors && invalidQuestions.includes(normalQuestionId)}
        resetErrors={resetErrors}
        onFreshSelection={() => setHasFreshSelection(true)}
        style={{ animationDelay: `${100}ms` }}
      />
    </>
  );
};
